export default class TestData {
    enums = {
        regNr: "registrationNumber",
        engineGearbox: "engine_gearbox_remarks",
        breaks: "breaks_remarks",
        technology: "technology_remarks",
        body: "body",
        interior: "interior",
        other: "other_remark",
        vdn: "url_product_declaration",
        tyreWinter: "tire_winter",
        tyreSummer: "tire_summer",
        mountedTyre: "tire_mounted",
        media: "media",
        separatelySoldWheelSet: "separately_sold_wheel_set"
    }

    checks = []
    condition = []
    images = []
    tyresets = []

    constructor(json) {
        this.json = json
        this.registrationNumber = json[this.enums.regNr]
        this.other_remark = json[this.enums.other]
        this.url_product_declaration = json[this.enums.vdn]
        this.mountedTyre = json[this.enums.mountedTyre]
        this.separatelySoldWheelSet = json[this.enums.separatelySoldWheelSet]

        this.addCheck(this.enums.engineGearbox)
        this.addCheck(this.enums.breaks)
        this.addCheck(this.enums.technology)

        this.addCondition(this.enums.body)
        this.addCondition(this.enums.interior)

        if (this.separatelySoldWheelSet !== 'vinter') {
            this.addTyreset(this.enums.tyreWinter);
        }
        if (this.separatelySoldWheelSet !== 'sommar') {
            this.addTyreset(this.enums.tyreSummer);
        }

        this.parseImages()
    }

    queryTitles(key) {
        switch (key) {
            case this.enums.engineGearbox:
                return "Motor & växellåda"
            case this.enums.breaks:
                return "Bromsar"
            case this.enums.technology:
                return "Teknik & utrustning"
            case this.enums.body:
                return "Kaross"
            case this.enums.interior:
                return "Interiör"
            case this.enums.tyreSummer:
                return "Sommardäck"
            case this.enums.tyreWinter:
                return "Vinterdäck"
            default:
                return ""
        }
    }

    queryTyreTitle(key) {
        switch (this.json[`${key}_type`]) {
            case "dubbade":
                return `Dubbade ${this.queryTitles(key)}`
            case "odubbade":
                return `Odubbade ${this.queryTitles(key)}`
            default:
                return this.queryTitles(key)
        }
    }

    addCheck(key) {
        this.checks.push({
            name: this.queryTitles(key),
            status: this.json[key] ? "FAIL" : "OK",
            notes: this.json[key] ? [this.json[key]] : []
        })
    }

    addCondition(key) {
        this.condition.push({
            name: this.queryTitles(key),
            state: this.json[`${key}_rating`],
            notes: this.json[`${key}_remarks`] ? [this.json[`${key}_remarks`]] : []
        })
    }

    getTyreDepthLimit(key) {
        return key === this.enums.tyreSummer ? 1.6 : 3
    }

    createTyre(key, suffix) {
        let positions = {
            "lf": "vf",
            "rf": "hf",
            "lb": "vb",
            "rb": "hb"
        }

        return {
            position: positions[suffix],
            patternDepth: this.json[`${key}_${suffix}`],
            note: this.json[`${key}_${suffix}`] <= this.getTyreDepthLimit(key) ? "Dåligt däckdjup" : ""
        }
    }

    addTyreset(key) {
        if (
            this.json[`${key}_lb`] &&
            this.json[`${key}_rb`] &&
            this.json[`${key}_lf`] &&
            this.json[`${key}_rf`]
        ) {

            this.tyresets.push({
                type: this.queryTyreTitle(key),
                description: this.json[`${key}_rim`] ? this.json[`${key}_rim`] : "",
                mounted: key === this.enums.tyreSummer ?
                    this.mountedTyre === "sommar" :
                    this.mountedTyre === "vinter",
                tyres: [
                    this.createTyre(key, 'lf'),
                    this.createTyre(key, 'rf'),
                    this.createTyre(key, 'lb'),
                    this.createTyre(key, 'rb')
                ]
            })
        }
    }

    parseImages(){
        function checkMimeType(m) {
            return ['image/jpeg', 'image/png', 'image/gif'].includes(m['mime_type']);
        }

        this.images = this.json[this.enums.media]
            .filter(checkMimeType)
            .map(m => m['original_url'])
    }
}